/**
 * スムーススクロール
 * @param {string} eventClass - ハンバーガーのクラス名（オプション）
 */
export function smoothScroll(eventClass) {
  const smoothScrollTrigger = document.querySelectorAll('[href^="#"]');

  const scrollToAnchor = function (targetElement) {
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const header = document.getElementById('header');
    const gap = header ? header.clientHeight : 0;
    const target = rect + offset - gap;

    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  };

  const closeNav = function () {
    if (!eventClass) return;

    const eventElm = document.getElementsByClassName(eventClass)[0];
    if (!eventElm) return;

    const targetClass = eventElm.dataset.target;
    const target = document.getElementsByClassName(targetClass)[0];
    const body = document.getElementsByTagName('body')[0];

    if (eventElm.classList.contains('is-active')) {
      eventElm.classList.toggle('is-active');
      target.classList.toggle('is-show');
      body.classList.toggle('is-nav-open');

      setTimeout(function () {
        target.style.transition = '';
      }, 1000);

      document.body.style.position = '';
      document.body.style.top = '';
    }
  };

  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (eventClass) {
        closeNav();
      }

      const href = smoothScrollTrigger[i].getAttribute('href');
      const targetElement = document.getElementById(href.replace('#', ''));
      if (targetElement) {
        scrollToAnchor(targetElement);
      }
    });
  }

  // URLハッシュがある場合のスクロール
  (function () {
    const urlHash = location.hash;
    if (urlHash) {
      window.scrollTo({ top: 0 });
    }
  })();

  window.addEventListener('load', function () {
    const urlHash = location.hash;
    if (urlHash) {
      window.scrollTo({ top: 0 });
      const targetElement = document.getElementById(urlHash.replace('#', ''));

      if (targetElement) {
        setTimeout(function () {
          scrollToAnchor(targetElement);
          setTimeout(function () {
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('page-loaded');
          }, 500);
        }, 500);
      } else {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('page-loaded');
      }
    }
  });
}
